import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationSwathWidth
} from 'services/equipmentSets/types';
import { makeSelectCalibrationSwathWidth } from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    swathWidth: CalibrationSwathWidth;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsSwathWidthListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { swathWidth } = this.props;

        return <ListItem description="Swath width" value={`${swathWidth}m`} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    swathWidth: makeSelectCalibrationSwathWidth()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsSwathWidthListItemComponent
);
